import { FEEDBACK_SUBMIT_REQUEST, FEEDBACK_RESET } from '../types';

export const submitFeedback = (payload) => ({
  type: FEEDBACK_SUBMIT_REQUEST,
  payload,
});

export const resetFeedback = () => ({
  type: FEEDBACK_RESET,
});
